import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import { localizeDate } from '../../../utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreAlarmLogsReportList',
  props: {
    smartGroupId: {
      type: Number,
      required: false,
      default: null
    },
    accountId: {
      type: Number,
      required: false,
      default: null
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showCreateDialog: false,
      selectedAccountIds: [],
      accountFilterReady: false,
      editingItem: null,
      itemIdToBeDeleted: null,
      accountFilterIsReady: false,
      cacheBuster: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color'])), {}, {
    tableHeaders: function tableHeaders() {
      var _this = this;

      return [{
        text: this.$i18n_t('Common.id'),
        value: 'id',
        sortable: true
      }, {
        text: this.$i18n_t('AlarmLogs.reports.wizard.name'),
        value: 'title',
        width: '350px',
        sortable: true
      }, {
        text: this.$i18n_t('Common.drawer.monitoringViews'),
        value: 'smartGroupId',
        width: '150px',
        sortable: true
      }, {
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.newErrors'),
        value: 'errorCount',
        sortable: false
      }, {
        text: this.$i18n_t('AlarmLogs.reports.wizard.tableItems.newWarnings'),
        value: 'warningCount',
        sortable: false
      }, {
        text: this.$i18n_t('AlarmLogs.table.headers.account'),
        value: 'tenantId',
        width: '150px',
        sortable: true
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.lastTriggered'),
        value: 'lastTrigger',
        sortable: true
      }, {
        text: this.$i18n_t('DeviceDriver.list.table.headers.actions'),
        isButtons: true,
        align: 'center',
        sortable: false,
        buttons: [{
          icon: 'fal fa-edit',
          color: this.color,
          onClick: function onClick(item) {
            _this.editItem(item);
          }
        }, {
          icon: 'fal fa-trash-alt',
          color: this.color,
          onClick: function onClick(item) {
            _this.onDeleteClick(item);
          }
        }]
      }].filter(function (item) {
        return !item.hide || !_this.$vuetify.breakpoint[item.hide];
      });
    }
  }),
  methods: {
    localizeDate: localizeDate,
    accountSelectionChanged: function accountSelectionChanged(accounts) {
      this.selectedAccountIds = accounts.map(function (account) {
        return account.id;
      });
    },
    fetchList: function () {
      var _fetchList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        var _this2 = this;

        var page, perPage, sortBy, sortDirection, selectedAccountIds, sortOrder, searchItems, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = options.page, perPage = options.perPage, sortBy = options.sortBy, sortDirection = options.sortDirection, selectedAccountIds = options.selectedAccountIds;
                sortOrder = {
                  variable: sortBy || 'id',
                  direction: sortDirection
                };
                searchItems = [];

                if (selectedAccountIds.length > 0) {
                  searchItems.push({
                    variable: 'tenantIds',
                    search: selectedAccountIds
                  });
                }

                if (this.smartGroupId != null) {
                  searchItems.push({
                    variable: 'smartGroupId',
                    search: this.smartGroupId
                  });
                }

                _context.next = 7;
                return ApiService.fetchAlarmLogReports(this, page, perPage, searchItems, sortOrder);

              case 7:
                response = _context.sent;
                return _context.abrupt("return", {
                  items: response.reports.map(function (report) {
                    return _objectSpread(_objectSpread({}, report), {}, {
                      title: report.meta.title,
                      smartGroupId: report.smartGroup.title,
                      tenantId: report.tenant.name,
                      errorCount: report.counts.newErrors,
                      warningCount: report.counts.newWarnings,
                      lastTrigger: report.lastTrigger ? _this2.localizeDate(report.lastTrigger) : '-'
                    });
                  }),
                  total: response.pagination.total
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchList(_x) {
        return _fetchList.apply(this, arguments);
      }

      return fetchList;
    }(),
    editItem: function editItem(item) {
      this.editingItem = cloneDeep(item);
      this.editingItem.tenantId = this.editingItem.tenant.id;
      this.editingItem.smartGroupId = this.editingItem.smartGroup.id;
      this.showCreateDialog = true;
    },
    reloadList: function reloadList() {
      this.closeDialog();
      this.cacheBuster++;
    },
    closeDialog: function closeDialog() {
      this.showCreateDialog = false;
      this.editingItem = null;
    },
    onDeleteClick: function onDeleteClick(item) {
      this.itemIdToBeDeleted = item.id;
    },
    onDeleteItemConfirm: function () {
      var _onDeleteItemConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var itemId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                itemId = this.itemIdToBeDeleted;
                _context2.prev = 1;
                _context2.next = 4;
                return ApiService.deleteAlarmReport(this, itemId);

              case 4:
                this.$snack(this.$i18n_t('AlarmLogs.snacks.reportDeleteSuccess'), 'success');
                this.cacheBuster += 1;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                console.error(_context2.t0);
                this.$snack(this.$i18n_t('AlarmLogs.snacks.reportDeleteError'), 'error');

              case 12:
                _context2.prev = 12;
                this.itemIdToBeDeleted = null;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8, 12, 15]]);
      }));

      function onDeleteItemConfirm() {
        return _onDeleteItemConfirm.apply(this, arguments);
      }

      return onDeleteItemConfirm;
    }()
  }
};